module.exports = __webpack_public_path__ + "img/ic_more.eb43c096.svg";